import React, { useState, useEffect } from 'react';

export const yearInputValues = (): {
    value: string;
    display: string;
}[] => {
    const yearStart = 1850;
    let yearEnd = new Date().getFullYear();

    const years: [{ value: string; display: string }] = [{ value: '', display: 'Select' }];

    while (yearStart < yearEnd + 1) {
        years.push({ value: yearEnd.toString(), display: yearEnd.toString() });
        yearEnd--;
    }

    return years;
};

export const YearInput = ({ id, value, onChange, required = false, disabled = false, maxWidth = 'auto' }) => {
    return (
        <select
            id={`${id}`}
            onChange={onChange}
            value={value}
            required={required}
            disabled={disabled}
            style={{ maxWidth: maxWidth }}
        >
            {yearInputValues().map((y) => {
                return (
                    <option
                        key={y.display + '_' + y.value}
                        value={y.value}
                    >
                        {y.display}
                    </option>
                );
            })}
        </select>
    );
};
